import React from 'react';
import PropTypes from 'prop-types';
import DaysLinks from '../days-links';
import BackLink from '../back-link';
import ButtonClear from '../button-clear';
import TicketsPanels from './tickets-panels';
import PopupLink from '../popup-link';
import { ROUTE_DAYS } from '../constants';
import PopupLinkInfo from '../popup-link-info';
import { domainConstants } from '../../../sso/components/utils/constants/domain-constants';
import { hasValue } from '../../../../general/js/general-helpers';

export default class SelectTicketsFormStandard extends React.Component {
    constructor(props) {
        super(props);
        this.formHeading = React.createRef();
    }

    componentDidMount() {
        this.formHeading.current.focus();
    }

    render() {
        const isWomensOpen = (window.location.hostname).toLowerCase();
        return (
            <div className="tb-form">
                <h2 className="tb-form__heading headline" tabIndex="-1"
                    ref={this.formHeading}>{this.props.dictionary.standardTicketsTitle}</h2>
                <DaysLinks productGroupsList={this.props.productGroupsList} />
                <div className="tb-form__header">
                    <h3 className="title">{this.props.dictionary.selectTicketsSubtitle}</h3>
                    {
                        hasValue(this.props.dictionary.ticketsInformationLinkUrl) &&
                        hasValue(this.props.dictionary.ticketsInformationLinkText) &&
                        <PopupLinkInfo
                            href={this.props.dictionary.ticketsInformationLinkUrl}>{this.props.dictionary.ticketsInformationLinkText}</PopupLinkInfo>
                    }
                </div>
                {isWomensOpen.includes((domainConstants.womensOpen).toLocaleLowerCase()) &&
                    <div className="tb-form__extraInfo copy">{this.props.dictionary.ticketExtraInformation}</div>}
                <TicketsPanels
                    dictionary={this.props.dictionary}
                    ticketsList={this.props.ticketsList}
                    productGroupsList={this.props.productGroupsList}
                    onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                />
                <div className="tb-form__footer">
                    <ButtonClear onClick={this.props.onClearSelection}>Clear Selection</ButtonClear>
                    <div className="tb-form__footer-copy copy">
                        {this.props.dictionary.selectStandardTicketsText}&nbsp;
                        {
                            hasValue(this.props.dictionary.selectStandardTicketsLinkUrl) &&
                            hasValue(this.props.dictionary.selectStandardTicketsLinkText) &&
                            <PopupLink
                                className="tb-form__footer-link link"
                                href={this.props.dictionary.selectStandardTicketsLinkUrl}
                                ariaLabel="see full price">{this.props.dictionary.selectStandardTicketsLinkText}</PopupLink>
                        }
                    </div>
                    {
                        (hasValue(this.props.dictionary.selectStandardTicketsInstructionsText1) ||
                        hasValue(this.props.dictionary.selectStandardTicketsInstructionsText2)) &&
						<div className="tb-form__footer-second-copy copy">
						    {this.props.dictionary.selectStandardTicketsInstructionsText1}
						    {
						        hasValue(this.props.dictionary.selectStandardTicketsInstructionsLinkText) &&
                                hasValue(this.props.dictionary.selectStandardTicketsInstructionsLinkUrl) &&
                                <a className="tb-form__footer-link link"
                                    href={this.props.dictionary.selectStandardTicketsInstructionsLinkUrl}
                                    aria-label="Edit basket"
                                    id="editBasket">{this.props.dictionary.selectStandardTicketsInstructionsLinkText}</a>
						    }
						    {this.props.dictionary.selectStandardTicketsInstructionsText2}
						</div>
                    }
                    <div className="tb-form__change-step">
                        <BackLink route={ROUTE_DAYS}>{this.props.dictionary.editDaysTitle}</BackLink>
                    </div>
                </div>
            </div>
        );
    }
}

SelectTicketsFormStandard.propTypes = {
    dictionary: PropTypes.object.isRequired,
    productGroupsList: PropTypes.array,
    ticketsList: PropTypes.array,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func,
};
